import { Component, Input } from '@angular/core';

@Component({
  selector: 'generate-order-option-svg',
  templateUrl: './generate-order.component.html',
  styleUrls: ['./../../../svg.scss']
})
export class GenerateOrderOptionSvgComponent {
  @Input() active:boolean=false;
  @Input() direction:string='';
  @Input() color: string='';
  constructor() { }

}
